<script lang="ts">
  import { onMount } from "svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./challenge-task.store";
  import { challengeTaskDtoFields } from "../../utils/TableFields/challenge-task-dto.fields";
  import ChallengeDetailTabs from "./ChallengeDetailTabs.svelte";

  export let challengeId: number;

  onMount(() => initList(challengeId));
</script>

<MainLayout>
  <ChallengeDetailTabs {challengeId} tasks={true} />

  <Table
    loading={$loading}
    fields={challengeTaskDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
